import React from 'react'
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

// import { Seo } from '../components/seo'
import Layout from '../layout/Layout';
import { FontAwesomeIcon } from '../libs/fonts'
import SectionHeading from '../components/SectionHeading/SectionHeading';

const Speaker = ({ pageContext }) => {
  const { data: speaker } = pageContext;

  return (
    <Layout>
      <div className='rs-about style1 pt-120 pb-120 md-pt-80 md-pb-75'>
        <div className='container'>
          <div className='row y-middle'>
            <div className='col-lg-12 pl-45 md-pl-15'>
              <SectionHeading subText='Speaker' title={speaker.name} borderLine />
              <div className='pt-40'>
                <GatsbyImage image={getImage(speaker.localFile)} alt=''/>
              </div>

              <div className='pt-20' style={{ display: 'flex' }}>
                {speaker.company && (
                  <div className='mr-20 company-title'>{speaker.company}</div>
                )}
                <ul className='social-icons' style={{ display: 'flex' }}>
                  {speaker.linkedin && (
                    <li className='mr-20'>
                      <a href={speaker.linkedin} target='_blank' rel='noreferrer'>
                        <FontAwesomeIcon
                          icon={`fa-brands fa-linkedin`}
                          style={{ fontSize: 22, color: 'black' }}
                        />
                        <span style={{ display: 'none' }}>LinkedIn link</span>
                      </a>
                    </li>
                  )}
                  {speaker.twitter && (
                    <li className='mr-20'>
                      <a href={`https://twitter.com/${speaker.twitter}`} target='_blank' rel='noreferrer'>
                        <FontAwesomeIcon
                          icon={`fa-brands fa-x-twitter`}
                          style={{ fontSize: 22, color: 'black' }}
                        />
                        <span style={{ display: 'none' }}>X link</span>
                      </a>
                    </li>
                  )}
                  {speaker.mastodon && (
                    <li className='mr-20'>
                      <a href={`https://mastodon.social/${speaker.mastodon}`} target='_blank' rel='noreferrer'>
                        <FontAwesomeIcon
                          icon={`fa-brands fa-mastodon`}
                          style={{ fontSize: 22, color: 'black' }}
                        />
                        <span style={{ display: 'none' }}>Mastodon link</span>
                      </a>
                    </li>
                  )}
                  {speaker.websiteUrl && (
                    <li className='mr-20'>
                      <a href={speaker.websiteUrl} target='_blank' rel='noreferrer'>
                        <FontAwesomeIcon
                          icon={`fa-solid fa-link`}
                          style={{ fontSize: 20, color: 'black' }}
                        />
                        <span style={{ display: 'none' }}>Website link</span>
                      </a>
                    </li>
                  )}
                </ul>
              </div>

              <div
                className='desc margin-0 pt-40 pb-25 inner-html'
                style={{ listStyle: 'auto' }}
                dangerouslySetInnerHTML={{ __html: speaker.biography.childMarkdownRemark.html }}
              />

              <SectionHeading title='Talks' borderLine />
              <ul className='pt-40'>
                {speaker.pretalxSubmissions
                  .filter(({ pretalxSubmission }) => pretalxSubmission.submission_type?.en === 'Talk')
                  .map(({ pretalxSubmission }) => {
                  return (
                    <li key={pretalxSubmission.id}>
                      <Link to={pretalxSubmission.path}>
                        {pretalxSubmission.title}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Speaker;

// export const Head = () => (
//     <Seo title='Speaker' />
// )
